// Real pages from ENGELSK KLAR™ Bind 1 (Gamma Studio), WebP 1512×1890 in Recursos Impultienda (tienda ENGELSK KLAR).
// InsidePages only shows entries with a src. Never use images from another product here.
const IMG_BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/79dccd1c-bd55-4996-abbb-ee0038764a5e/';

export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    src: `${IMG_BASE}1792695415526_engelskklar-bind1-s01-forside-667ec178.webp`,
    label: 'Bind 1 · Forside',
    title: 'Årsplan og 12 ferdige engelsktimer',
    text: 'Bind 1 samler årshjulene for 1.–10. trinn og tolv engelsktimer minutt for minutt – med elevark i tre nivåer og fasit.'
  },
  {
    src: `${IMG_BASE}1792695419565_engelskklar-bind1-s04-arshjul-108123ac.webp`,
    label: 'Årshjul · Side 4',
    title: 'Årshjulet for 1.–4. trinn',
    text: 'Tema for hver måned – fra «Hello! Greetings and names» i august til «Summer holiday words» i juni.'
  },
  {
    src: `${IMG_BASE}1792695423549_engelskklar-bind1-s13-time1-a9bcaf13.webp`,
    label: 'Time 1 · Side 13',
    title: 'Time 1: Hello! Greetings minutt for minutt',
    text: 'Lærerens side: oppstart 0–10, hoveddel 10–35 og avslutning 35–45, med mål, materiell, lærerens instruksjon og key phrases.'
  },
  {
    src: `${IMG_BASE}1792695427657_engelskklar-bind1-s16-elevark-colours-6b96d7d5.webp`,
    label: 'Elevark · Side 16',
    title: 'Elevark i tre nivåer: Colour by word',
    text: 'Samme oppgave i Level 1, 2 og 3 – hele klassen jobber med fargene, hver på sitt nivå.'
  },
  {
    src: `${IMG_BASE}1792703804697_engelskklar-bind1-s22-elevark-animal-riddles-101e558b.webp`,
    label: 'Elevark · Side 22',
    title: 'Time 5: Animal riddles',
    text: 'Elevark for 3.–4. trinn i tre nivåer: koble dyr og ord, gjett gåtene og skriv din egen gåte med «It is … It can … It can’t …».'
  }
];
